const defaultState = null;

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_MODAL_PROCUREMENT_ITEM':
      return action.item;
    case 'CLEAR_MODAL_PROCUREMENT_ITEM':
      return null;
    default:
      return state;
  }
};
